<!-- Ported from the Polaris kit: src/components/ui/sidebar/SidebarGroupLabel.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { Primitive } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <Primitive
    data-slot="sidebar-group-label"
    data-sidebar="group-label"
    :as="as"
    :as-child="asChild"
    :class="
      cn(
        'text-polaris-sidebar-foreground/70 ring-polaris-sidebar-ring flex h-8 shrink-0 items-center rounded-polaris-md px-2 type-polaris-small-label outline-none transition-[margin,opacity] duration-200 ease-linear focus-visible:ring-[2px] [&>svg]:size-4 [&>svg]:shrink-0',
        'group-data-[collapsible=icon]:pointer-events-none group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:select-none group-data-[collapsible=icon]:opacity-0',
        props.class
      )
    "
  >
    <slot />
  </Primitive>
</template>
